import { render, staticRenderFns } from "./PartnerReportCardRegistrationDate.vue?vue&type=template&id=4d5d7b6c&scoped=true&"
import script from "./PartnerReportCardRegistrationDate.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportCardRegistrationDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d7b6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
